export enum ImsCostingMethod {
  Legacy = "legacy",
  WeightedAverage = "weighted_average",
  Fifo = "fifo",
}
